import { render, staticRenderFns } from "./add-inquiry-modal.vue?vue&type=template&id=1b6a68f8&scoped=true&"
import script from "./add-inquiry-modal.vue?vue&type=script&lang=js&"
export * from "./add-inquiry-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-inquiry-modal.vue?vue&type=style&index=0&id=1b6a68f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a68f8",
  null
  
)

component.options.__file = "add-inquiry-modal.vue"
export default component.exports